import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    // see https://mui.com/material-ui/customization/theming/ for documentation
});